import { NgModule } from '@angular/core';
// import { refreshTokenInterceptorProvider } from './refresh-token.interceptor';

@NgModule({
  // providers: [ refreshTokenInterceptorProvider ]
})
export class ZefAuthRefreshTokenModule {

}
